export default "__VITE_ASSET__B70i7_Kc__"